import { makeLookup } from '@aloft/toolkit-shared';

import { SectionID } from './types.ts';

export const getSectionTitle = makeLookup<SectionID, string>({
  cases: [
    ['users', 'User Management'],
    ['regression', 'Regression Modelling'],
    ['imageAnalysis', 'Image Analysis'],
  ],
});
